import {createStyles, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import { BACKGROUND_SECONDARY } from '../../../const/colors';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        radioWrapper: {
            border: `1px solid ${BACKGROUND_SECONDARY}`,
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            fontSize: '20px',
            fontWeight: 700,
            height: 72,
            [theme.breakpoints.down('xs')]: {
                height: 56,
            },
        },
        formControlWrapper: {
            width: '100%',
            height: '100%',
        },
        radio: {marginRight: 8},
        selectedRadioWrapper: {
            backgroundColor: BACKGROUND_SECONDARY,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
        radioText: {
            fontSize: '20px',
            fontWeight: 700
        },
        optionContent: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
        },
        contentBackground: {
            backgroundColor: BACKGROUND_SECONDARY,
        },
        image: {
            display: 'block',
            width: '100%',
            maxWidth: 380,
            height: 'auto',
            margin: '0 auto',
        },
    }),
);

export default useStyles;
